// UserProfileEmergency.tsx
import React from "react";
import { TeamMember } from "../../../types/admin/TeamTypes";
import { Input, Row, Col, Typography, Alert } from "antd";

const { Text } = Typography;

interface UserProfileEmergencyProps {
	teamMember: TeamMember;
	isEditing: boolean;
	setTeamMember: React.Dispatch<React.SetStateAction<TeamMember | null>>;
}

interface EmergencyContact {
	name: string;
	relationship: string;
	phone: string;
}

const UserProfileEmergency: React.FC<UserProfileEmergencyProps> = ({ teamMember, isEditing, setTeamMember }) => {
	const handleEmergencyContactChange = (field: keyof EmergencyContact, value: string) => {
		setTeamMember((prev) => {
			if (!prev) return null;
			const prevContact = prev.team_member_info?.emergency_contact || {};
			return {
				...prev,
				team_member_info: {
					...prev.team_member_info,
					emergency_contact: { ...prevContact, [field]: value },
				},
			};
		});
	};

	const emergencyContact = teamMember.team_member_info?.emergency_contact || {};

	return (
		<div>
			<Row gutter={[16, 16]}>
				<Col xs={24} md={8}>
					<div>
						<Text type="secondary" style={{ fontSize: 11 }}>Contact Name</Text>
						{isEditing ? (
							<Input value={emergencyContact.name || ""} onChange={(e) => handleEmergencyContactChange("name", e.target.value)} placeholder="Full name" style={{ marginTop: 4 }} />
						) : (
							<Text style={{ fontSize: 13, display: "block", marginTop: 4 }}>{emergencyContact.name || "—"}</Text>
						)}
					</div>
				</Col>

				<Col xs={24} md={8}>
					<div>
						<Text type="secondary" style={{ fontSize: 11 }}>Relationship</Text>
						{isEditing ? (
							<Input value={emergencyContact.relationship || ""} onChange={(e) => handleEmergencyContactChange("relationship", e.target.value)} placeholder="e.g., Spouse, Parent" style={{ marginTop: 4 }} />
						) : (
							<Text style={{ fontSize: 13, display: "block", marginTop: 4 }}>{emergencyContact.relationship || "—"}</Text>
						)}
					</div>
				</Col>

				<Col xs={24} md={8}>
					<div>
						<Text type="secondary" style={{ fontSize: 11 }}>Phone Number</Text>
						{isEditing ? (
							<Input value={emergencyContact.phone || ""} onChange={(e) => handleEmergencyContactChange("phone", e.target.value)} placeholder="+61 400 000 000" style={{ marginTop: 4 }} />
						) : (
							<Text style={{ fontSize: 13, display: "block", marginTop: 4 }}>{emergencyContact.phone || "—"}</Text>
						)}
					</div>
				</Col>
			</Row>

			{!isEditing && !emergencyContact.name && (
				<Alert message="No emergency contact information provided" type="info" showIcon style={{ marginTop: 16 }} />
			)}
		</div>
	);
};

export default UserProfileEmergency;
